__webpack_require__.p = "https://static.spqr.app/f9171849cbed86dd967c815a6a740fae1c2caa10/_next/";